module.exports = __webpack_public_path__ + "img/banner-5.bdec2c29.png";